import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'normalize-css';
import 'typeface-open-sans';
import 'typeface-montserrat';
import 'typeface-raleway';
import { initAmplitude } from './utils/amplitude';

initAmplitude();

ReactDOM.render(<App />, document.getElementById('root'));
